import {Component} from '@angular/core';

@Component({
  selector: 'app-debitor-account-help',
  standalone: true,
  imports: [],
  templateUrl: './debitor-account-help.component.html',
  styleUrl: './debitor-account-help.component.scss'
})
export class DebitorAccountHelpComponent {

}
